/** Where readers of the public site are told to write. Single place to change. */
export const CONTACT_EMAIL = "irei@hi.is";

/**
 * Official pages for the third-party tools the site names. Linked so that
 * nobody has to search an app store for "authenticator" and guess which of the
 * lookalikes is genuine — a real risk for a 2FA app.
 */
export const LINKS = {
  googleAuthenticator: "https://support.google.com/accounts/answer/1066447",
  microsoftAuthenticator: "https://www.microsoft.com/en-us/security/mobile-authenticator-app",
  authy: "https://authy.com/download/",
  onePassword: "https://support.1password.com/one-time-passwords/",
  freeOtp: "https://freeotp.github.io/",
  totpRfc: "https://datatracker.ietf.org/doc/html/rfc6238",
  pwnedPasswords: "https://haveibeenpwned.com/Passwords",
  gdpr: "https://eur-lex.europa.eu/eli/reg/2016/679/oj",
  personuvernd: "https://www.personuvernd.is/",
  rafraenSkilriki: "https://www.skilriki.is/",
  vault: "https://www.vaultproject.io/",
  aesGcm: "https://csrc.nist.gov/pubs/sp/800/38/d/final",
  jupyter: "https://jupyter.org/",
  rProject: "https://www.r-project.org/",
} as const;
